import { useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { SET_USER } from 'src/store/userReducer';
// routes
import { useRouter } from 'src/routes/hooks';
//
import { UrlContext } from 'src/context/Context';
import { useAuthContext } from '../hooks';

export default function AuthForm({ children, setUser }) {
  const { user } = useAuthContext();

  useEffect(() => {
    if (user !== null) {
      setUser(user);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return <>{children}</>;
}

AuthForm.propTypes = {
  setUser: PropTypes.func,
  children: PropTypes.node,
};

const mapStateToProps = (state) => ({ user: state.user, settings: state.settings });

const mapDispatchToProps = (dispatch) => ({
  setUser: (user) => dispatch({ type: SET_USER, payload: user }),
});

export const AuthFormStore = connect(mapStateToProps, mapDispatchToProps)(AuthForm);
